import { render, staticRenderFns } from "./order-total.vue?vue&type=template&id=2a15763c"
import script from "./order-total.vue?vue&type=script&lang=js"
export * from "./order-total.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports